// uncomment for DEV
// export const API_URL = 'https://imasmd.vision.digicode.ro/offline'
// export const API_URL1 = 'https://imasmd.vision.digicode.ro/'
// export const API_URL_PROJECT_ID = 'https://imasmd.vision.digicode.ro/offline/answer/save/'
// export const API_URL_RECORDING  = 'https://imasmd.vision.digicode.ro/offline/recording/save'
// export const API_URL_QUESTIONNAIRE_API = 'https://autonom.marianadascalitei.dev.ascensys.ro/questionnaire_api.php'
// export const DEV_MEDIA_URL = 'https://imasmd.vision.digicode.ro/offline_quiz/static/media/'
// export const API_URL_PICTURES = 'https://imasmd.vision.digicode.ro'
//-----------------------------

// uncomment for VISION
export const API_URL = '/offline'
export const API_URL1 = '/'
export const API_URL_PROJECT_ID = '/offline/answer/save/'
export const API_URL_RECORDING  = '/offline/recording/save'
export const API_URL_QUESTIONNAIRE_API = 'https://autonom.marianadascalitei.dev.ascensys.ro/questionnaire_api.php'
export const DEV_MEDIA_URL = '/offline_quiz/static/media/'
export const API_URL_PICTURES = '/'